import { useLayoutEffect } from "react"

import { useDispatch } from "react-redux"

import ReferralActions from "../../reducer"
import Benefits from "./Benefits"
import Faq from "./Faq"
import HowItWorks from "./HowItWorks"

import "./styles.less"

const InfoBlock = () => {
  const dispatch = useDispatch()

  useLayoutEffect(() => {
    dispatch(ReferralActions.getFaqRequest())
  }, [])

  return (
    <div>
      <HowItWorks />
      <Benefits />
      <Faq />
    </div>
  )
}

export default InfoBlock
